import { Header, EditMessageGroup as EditMessageGroupComponent } from "components"
export const EditMessageGroup = () => {
 return (
  <div>
   <Header />
   <EditMessageGroupComponent />
  </div>
 )
}
